import React, { useContext } from "react";

import Container from "@material-ui/core/Container";
import { makeStyles } from "@material-ui/core/styles";
import { AuthContext } from "../../context/Auth/AuthContext.js";

const useStyles = makeStyles((theme) => ({
  mainContainer: {
    flex: 1,
    padding: theme.spacing(2),
    [theme.breakpoints.down('sm')]: {
      padding: theme.spacing(1),
    },
    height: `100dvh`,
  },
  mainContainerHorizontal: {
    height: "calc(100% - 48px)",
    flex: 1,
    padding: theme.spacing(2),
    [theme.breakpoints.down('sm')]: {
      padding: theme.spacing(1),
    },
  },
  contentWrapper: {
    height: "100%",
    overflowY: "hidden",
    display: "flex",
    flexDirection: "column",
  },
}));

const MainContainer = ({ children, className, style }) => {
  const classes = useStyles();
  const { isHorizontal } = useContext(AuthContext);
  return (
    <Container
  className={`${isHorizontal ? classes.mainContainerHorizontal : classes.mainContainer} ${className || ""}`}
  style={style}
    >
      <div className={classes.contentWrapper}>{children}</div>
    </Container>
  );
};

export default MainContainer;
